<template lang="pug">
.page 
    a-drawer(:visible="drawerVisible" 
        :width="500"
        title="约券申请"
        @close="drawerVisible = false")
        a-table(:columns="submitColumns" 
            size="small"
            :dataSource="submitItems" 
            rowKey="code")
        a-button(type="primary" @click="submit") 提交
    a-spin(:spinning="pageLoading")
        .ctl-bar
            
            a-button.action(type="primary" @click="getData")
                a-icon(type="redo")
                span 刷新
            a-button.action(type="primary" @click="exportPool")
                a-icon(type="download") 
                span 下载约券池
            a-upload.action(name="submit"
                accept=".csv"
                :showUploadList="false"
                :beforeUpload="beforeUpload")
                a-button(type="primary")
                    a-icon(type="upload")
                    span 约券申请
        a-tabs 
            a-tab-pane(key="product", tab="产品账户")
                a-table(:columns="productColumns" 
                    size="small"
                    :loading="loading"
                    :dataSource="products" rowKey="keyCtptyId")
            a-tab-pane(key="items", tab="约券申请记录")
                a-table(:columns="columns" 
                    size="small"
                    :loading="loading"
                    :dataSource="items" rowKey="keyEqReserveId")    
</template>

<script>
export default {
    data() {
        return {
            drawerVisible: false,
            pageLoading: false,
            loading: false,
            submitItems: [],
            submitColumns: [
                {
                    title: '产品账户 ID',
                    dataIndex: 'keyCtptyId',
                },
                {
                    title: '标的代码',
                    dataIndex: 'code',
                },
                {
                    title: '申请数量',
                    dataIndex: 'qty'
                }
            ],
            products: [],
            productColumns: [
                {
                    title: '产品账户 ID',
                    dataIndex: 'keyCtptyId',
                },
                {
                    title: '产品账户短名',
                    dataIndex: 'ctptyShortname',
                },
                {
                    title: '产品账户长名',
                    dataIndex: 'ctptyLongname',
                },
                {
                    title: '客户名称',
                    dataIndex: 'ctptyLegalEntity'
                }
            ],
            items: [],
            columns: [
                // {
                //     title: '申请日期',
                //     dataIndex: 'applyDate',
                // },
                {
                    title: '申请时间',
                    dataIndex: 'applyTime',
                },
                {
                    title: '交易日期',
                    dataIndex: 'tradeDate',
                },
                {
                    title: '标的名称',
                    dataIndex: 'insShtDesc',
                },
                // {
                //     title: '申请编号 ID',
                //     dataIndex: 'keyEqReserveId',
                // },
                {
                    title: '标的代码',
                    dataIndex: 'windCode',
                },
                {
                    title: '申请数量',
                    dataIndex: 'applyQty',
                },
                {
                    title: '审批数量',
                    dataIndex: 'approveQty',
                },
                {
                    title: '期限',
                    dataIndex: 'term',
                },
                {
                    title: '申请券息',
                    dataIndex: 'interestRate'
                },
                {
                    title: '借入利率',
                    dataIndex: 'approveInterestRate',
                },
                {
                    title: '约定模式',
                    dataIndex: 'promiseType'
                },
                {
                    title: '交易方式',
                    dataIndex: 'tradeType'
                },
                {
                    title: '申请状态',
                    dataIndex: 'orderStatus',
                },
                {
                    title: 'tradeChannel',
                    dataIndex: 'tradeChannel'
                }
            ]
        };
    },
    mounted() {
        this.getData();
        this.getProductInfo();
    },
    methods: {
        getData() {
            this.loading = true;
            this.$api.request('POST', 'lend/get_quota_order_list')
                .then(res => {
                    if (res.data.errCode.code == 200) {
                        this.items = res.data.data.queryResults;
                    }
                    else {
                        this.$message.error(res.data.errCode.chs);
                    }
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;   
                });
            
        },
        getProductInfo() {
            this.$api.request('POST', 'lend/user/get_products_info')
                .then(res => {
                    this.products = res.data.data;
                //    console.log(res.data); 
                });
        },
        jsonToCsv(collectionData) {
            let csv = '';
            let header = Object.keys(collectionData[0]).join(',') + '\n';
            csv += header;
            collectionData.forEach(item => {
                let row = Object.values(item).join(',') + '\n';
                csv += row;
            });
            return csv;
        },
        csvToJson(csv) {
            let lines = csv.split('\n');
            let result = [];
            let headers = lines[0].trim().split(',');

            for (let i = 1; i < lines.length; i++) {
                let obj = {};
                let currentline = lines[i].trim().split(',');
                if (currentline.length != headers.length) continue;

                for (let j = 0; j < headers.length; j++) {
                    obj[headers[j]] = currentline[j];
                }
                result.push(obj);
                
            }
            return result;
        },
        async beforeUpload(file) {
            if(!(/\.csv$/.test(file.name))) return false;
            let fr = new FileReader();

            let p = new Promise((resolve, reject) => {
                fr.onload = () => {
                    resolve(fr.result);
                };
                fr.onerror = reject;
            });

            fr.readAsText(file);

            let content = await p;
            this.drawerVisible = true;
            this.submitItems = this.csvToJson(content);
            console.log(content);
            console.log(this.submitItems);
            return false;
        },
        async submit() {
            let hadSumit = false;
            let isFail = false;
            let p = Promise.all(this.submitItems.map(async item => {
                if (item.code && item.qty && item.keyCtptyId) {
                    hadSumit = true;
                    let res = await this.$api.request('POST', 'lend/submit_quota_order', {
                        keyCtptyId: parseInt(item.keyCtptyId),
                        criterionCode: item.code,
                        applyQty: parseInt(item.qty),
                    });
                    if (res.data.errCode.code != 200) {
                        isFail = true;
                        this.$message.error(res.data.errMsg);
                    }
                }
            }));

            try {
                await p;
                if (hadSumit) {
                    if (!isFail) {
                        this.$message.success('提交成功');
                        this.getData();
                    } 
                }
                else {
                    this.$message.error('没有可提交的数据');
                }
            } catch (error) {
                this.$message.error('提交失败');
            }
        },
        exportPool() {
            this.pageLoading = true;
            this.$api.request('POST', 'lend/get_lendSwap_pool').then(res => {
                if (res.data.errCode.code == 200) {
                    let url = window.URL.createObjectURL(new Blob([this.jsonToCsv(res.data.data)]));
                    let docUrl = document.createElement('a');
                    docUrl.href = url;
                    docUrl.setAttribute('download', '约券池.csv');
                    document.body.appendChild(docUrl);
                    docUrl.click();
                    window.URL.revokeObjectURL(url);
                    docUrl.remove();
                }
                else {
                    this.$message.error(res.data.errCode.chs);
                }
                this.pageLoading = false;
            })
            .catch(err => {
                this.pageLoading = false;
            })
                
        }
    }
}
</script>

<style lang="less" scoped>
.action {
    margin-right: 10px;
}
</style>